package org.ttt.autogenesis.kvisionapp.mapUpload

import org.ttt.autogenesis.network.*
import kotlinx.serialization.builtins.*

internal fun registerMapUploadSuccessClientHandlersRpcHandlers(rpcRegistry : RpcRegistry, target : org.ttt.autogenesis.kvisionapp.mapUpload.MapUploadSuccessClientHandlers)
{

    rpcRegistry.registerTyped(
        method = "Map.Upload.Success",
        direction = RpcDirection.CLIENT,
        serializer = org.ttt.autogenesis.network.MapUploadSuccessData.serializer(),
        resultSerializer = kotlin.Unit.serializer()
    ) { ctx, payload ->
        target.handleMapUploadSuccess(ctx, payload)
        null
    }
}

internal class MapUploadSuccessClientHandlersRpcHandlersRegistrationProvider(private val target : org.ttt.autogenesis.kvisionapp.mapUpload.MapUploadSuccessClientHandlers) : RpcRegistrationProvider
{
    override fun register(rpcRegistry : RpcRegistry)
    {
        registerMapUploadSuccessClientHandlersRpcHandlers(rpcRegistry, target)
    }
}

internal val _mapUploadSuccessClientHandlersRpcHandlersProvider = MapUploadSuccessClientHandlersRpcHandlersRegistrationProvider(org.ttt.autogenesis.kvisionapp.mapUpload.MapUploadSuccessClientHandlers).also {
    RpcRegistrationCollector.registerProvider(it)
}
